// ** React Imports
import { createRoot } from 'react-dom/client'
import React, { Suspense, lazy } from 'react'
import { BrowserRouter } from 'react-router-dom'

// ** Redux Imports
import { store } from './store'
import { Provider } from 'react-redux'

// ** Intl, CASL & ThemeColors Context
import 'react-phone-input-2/lib/style.css'
import './@core/scss/react/libs/flatpickr/flatpickr.scss'
import { ThemeContext } from './utility/context/ThemeColors'

// ** ThemeConfig
import themeConfig from './configs/themeConfig'

// ** Toast
import { Toaster } from 'react-hot-toast'

// ** i18n
import './configs/i18n'

// ** Spinner (Splash Screen)
import Spinner from './@core/components/spinner/Fallback-spinner'

// ** Ripple Button
import './@core/components/ripple-button'

// ** PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import 'prismjs/components/prism-jsx.min'

// ** React Perfect Scrollbar
import 'react-perfect-scrollbar/dist/css/styles.css'

// ** React Hot Toast Styles
// import '@styles/react/libs/react-hot-toasts/react-hot-toasts.scss'

// ** Core styles
import './@core/assets/fonts/feather/iconfont.css'
import './@core/scss/core.scss'
import './@core/scss/custom.scss'
import './assets/scss/style.scss'

// ** Service Worker
import './configs/interceptors/interceptors'

// ** React Query
import {
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query"
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'

// ** MUI Imports
import { CssBaseline, ThemeProvider } from '@mui/material';

// ** Google OAuth
import { GoogleOAuthProvider } from '@react-oauth/google';
import theme from './theme'

// ** Lazy load app
const LazyApp = lazy(() => import('./App'))

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
      retryDelay: 0,
      refetchOnWindowFocus: false,
    }
  }
})

const container = document.getElementById('root')
const root = createRoot(container!)

// 404 sayfasından gelen fallback path'i kontrol etme
const fallbackPath = localStorage.getItem('spa-fallback-path');
if (fallbackPath) {
  localStorage.removeItem('spa-fallback-path');
  window.history.replaceState(null, '', fallbackPath);
}

// Subdomain check için basename belirleme
const getBasename = () => {
  const hostname = window.location.hostname;
  // Subdomain kontrolü
  if (hostname.includes('app.')) {
    return '/';
  }
  return '/';
};

root.render(
  <BrowserRouter basename={getBasename()}>
    <React.StrictMode>
      <GoogleOAuthProvider clientId={import.meta.env.VITE_APP_GOOGLE_CLIENT_ID}>
        <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <Suspense fallback={<Spinner />}>
            <ThemeProvider theme={theme}>
              <CssBaseline />
              <ThemeContext>
                <LazyApp />
                <Toaster
                  position={'top-center'}
                  toastOptions={{ className: 'react-hot-toast' }}
                />
              </ThemeContext>
            </ThemeProvider>
          </Suspense>
        </Provider>
        {/* <ReactQueryDevtools initialIsOpen={false} /> */}
      </QueryClientProvider>
      </GoogleOAuthProvider>
    </React.StrictMode>
  </BrowserRouter>
)
